import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'
import { FaBars } from 'react-icons/fa'
//Hamburger
const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false)

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar)
  }

  return (
    <nav className="navbar">
      <div className="container">
        <div className="homeBrand">
        <NavLink to="/">FxHub</NavLink>
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <FaBars className='icon-bars'/>
        </div>
        <div className={`nav-elements  ${showNavbar && 'active'}`}>
          <ul>
            <li>
            <NavLink to="/subscription">Subscription</NavLink>
            </li>
            <li>
              <NavLink to="/getfunded">Fund Wallet</NavLink>
            </li>
            <li>
              <NavLink to="/bots">Trading Bots</NavLink>
            </li>
            <li>
              <NavLink to="/learn">Learning</NavLink>
            </li>
            <li>
              <NavLink to="/overview">Market Overview</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Navbar